var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useState, useEffect } from "react";
import "@frameworks/web/stylesheets/components/generic/footer/footerfeedbackpop.scss";
import uploadImage from "@frameworks/shared-library/assets/images/SalesJourney/uploadImage.svg";
export var FileUploadSection = function (props) {
    var _a, _b;
    var _c = __read(useState(false), 2), docUploaded = _c[0], setDocUploaded = _c[1];
    var _d = __read(useState(false), 2), fileError = _d[0], setFileError = _d[1];
    var _e = __read(useState(""), 2), fileErrorMsg = _e[0], setFileErrorMsg = _e[1];
    var _f = __read(useState(false), 2), fileTypeError = _f[0], setFileTypeError = _f[1];
    var _g = __read(useState(""), 2), docFile = _g[0], setDocFile = _g[1];
    var _h = __read(useState(""), 2), fileSizeinMB = _h[0], setFileSizeinMB = _h[1];
    var _j = __read(useState(""), 2), fileExtension = _j[0], setFileExtension = _j[1];
    useEffect(function () {
        if (props.reset) {
            resetForm();
        }
    }, [props.reset]);
    useEffect(function () {
        if (props.fileName) {
            setDocUploaded(true);
            setDocFile(props.fileName);
        }
    }, []);
    var resetForm = function () {
        setDocUploaded(false);
        setDocFile("");
        setFileError(false);
        setFileTypeError(false);
    };
    var onSelectFile = function (e) {
        var _a, _b, _c;
        var files = (_a = e.target) === null || _a === void 0 ? void 0 : _a.files;
        uploadFile((_b = e.target) === null || _b === void 0 ? void 0 : _b.files[0]);
        var fileSizeInBytes = (_c = files[0]) === null || _c === void 0 ? void 0 : _c.size;
        var fileSizeInMB = fileSizeInBytes / (1024 * 1024);
        setFileSizeinMB(fileSizeInMB === null || fileSizeInMB === void 0 ? void 0 : fileSizeInMB.toFixed(2));
    };
    var uploadFile = function (file) {
        var _a, _b;
        resetForm();
        if (file) {
            var extensions = file.name.split(".");
            setFileExtension(extensions[1].toUpperCase());
            if (!props.fileType.find(function (val) { return extensions[1].toLowerCase() === val.toLowerCase(); })) {
                if (((_a = file.name) === null || _a === void 0 ? void 0 : _a.length) > 0 && ((_b = file.name.match(/\./g)) === null || _b === void 0 ? void 0 : _b.length) >= 2) {
                    setFileErrorMsg("Uploaded file contains more than one dot. please rename and contains only .extension in the name");
                }
                else {
                    setFileErrorMsg("");
                }
                setFileTypeError(true);
                return;
            }
            if (fileError)
                setFileError(false);
            if ((props === null || props === void 0 ? void 0 : props.fileSize) && file.size > props.fileSize) {
                setFileError(true);
                return;
            }
            setDocFile(file.name);
            var reader_1 = new FileReader();
            reader_1.readAsDataURL(file);
            reader_1.onload = function (result) {
                if ((reader_1 === null || reader_1 === void 0 ? void 0 : reader_1.result) && props.onSubmit) {
                    props.onSubmit({
                        base64Data: reader_1 === null || reader_1 === void 0 ? void 0 : reader_1.result,
                        docFile: file === null || file === void 0 ? void 0 : file.name,
                    });
                }
                setDocUploaded(true);
                // resetForm();
            };
        }
    };
    var removeUploadFile = function () {
        if (docFile) {
            setDocFile("");
            if (props === null || props === void 0 ? void 0 : props.onSubmit)
                props.onSubmit({
                    base64Data: "",
                    docFile: "",
                });
        }
        resetForm();
    };
    var dropHandler = function (e) {
        e.preventDefault();
        if (e.dataTransfer.items) {
            for (var i = 0; i < e.dataTransfer.items.length; i++) {
                if (e.dataTransfer.items[i].kind === "file") {
                    uploadFile(e.dataTransfer.items[i].getAsFile());
                }
            }
        }
    };
    return (React.createElement(React.Fragment, null,
        !docUploaded && (React.createElement("label", { className: "uploadWrap hand_cursor", onDrop: dropHandler, onDragOver: function (e) { return e.preventDefault(); }, onDragEnter: function (e) { return e.preventDefault(); } },
            React.createElement("input", { type: "file", onChange: onSelectFile, className: "display-none", id: "feedBackFile", accept: (props === null || props === void 0 ? void 0 : props.acceptFileType) ? props === null || props === void 0 ? void 0 : props.acceptFileType : "*", onClick: function (e) { return (e.target.value = ""); } }),
            React.createElement("div", null,
                React.createElement("div", null,
                    React.createElement("label", { htmlFor: "feedBackFile", id: "upload-icon", className: "fs-20 cursor-pointer" }, (props === null || props === void 0 ? void 0 : props.uploadIcon) ? (props === null || props === void 0 ? void 0 : props.uploadIcon) : (React.createElement("img", { src: uploadImage })))),
                React.createElement("div", null,
                    React.createElement("label", { htmlFor: "feedBackFile", className: "upload-content" }, (_a = props === null || props === void 0 ? void 0 : props.placeholder) !== null && _a !== void 0 ? _a : "Drag & drop your screenshot here or click here to upload"))))),
        fileTypeError && (React.createElement("div", null, fileErrorMsg && (fileErrorMsg === null || fileErrorMsg === void 0 ? void 0 : fileErrorMsg.length) > 0 ? (React.createElement("p", { className: "uploadError" }, fileErrorMsg)) : (React.createElement("p", { className: "uploadError" },
            "Please upload only ",
            "." + props.fileType.join(", ."),
            " Files.")))),
        fileError && (React.createElement("div", null,
            React.createElement("p", { className: "uploadError" }, "Please upload correct file and Its size should be less than ".concat((_b = props === null || props === void 0 ? void 0 : props.fileSizeInMB) !== null && _b !== void 0 ? _b : "8MB", " .")))),
        docFile &&
            ((props === null || props === void 0 ? void 0 : props.showColouredIcon) ? (React.createElement("div", { className: "d-flex uploaded-fileColoured" },
                React.createElement("div", { className: "first-block" },
                    React.createElement("i", { className: "edel-icon-reporting" })),
                React.createElement("div", { className: "DMSanM_10_500 second-block" },
                    React.createElement("div", { className: "docfile" },
                        React.createElement("span", { className: "docfile-text" }, docFile)),
                    React.createElement("p", { className: "txt_secondary-gray" }, fileSizeinMB !== null && fileSizeinMB !== void 0 ? fileSizeinMB : "",
                        " mb ",
                        fileExtension)),
                React.createElement("div", { className: "uploaded-fileClose cursor-pointer", onClick: removeUploadFile },
                    React.createElement("i", { className: "edel-icon-red-cross" })))) : (React.createElement("div", { className: "uploadSectionWrap" },
                React.createElement("div", { className: "fileNameSec" },
                    React.createElement("div", { className: "uploaded-fileName" },
                        React.createElement("p", null, docFile)),
                    React.createElement("div", { className: "uploaded-fileClose", onClick: removeUploadFile },
                        React.createElement("i", { className: "edel-icon-close" }))))))));
};
